import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import InvoiceRequestBody from "./InvoiceRequestBody";

export default class InvoiceService {
  request = new InvoiceRequestBody();
  static shared = new InvoiceService();


  invoicesListRequest = (payload) => {
     return new Promise((resolve, reject) => {
      WebService.clientShared  
        .callServiceApi(
          ApiUrl.getExistingInvoices(payload.userId, payload.projectName ,payload.fromDate, payload.page, payload.size),
          this.request.invoiceListRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }); 
  }

  updateInvoiceRequest = (payload,id) => {
    return new Promise((resolve, reject) => {
     WebService.clientShared  
       .callServiceApi(
         ApiUrl.updateInvoice(id),
         this.request.updateInvoiceRequest(REQUEST_METHOD.PUT,payload)
       )
       .then((response) => {
         resolve(response);
       })
       .catch((error) => {
         reject(error);
       });
   }); 
 } 


 reGenerateInvoicePDFRequest = (payload) =>{
  return new Promise ((resolve, reject) =>{
    WebService.clientShared
    .callServiceApi(
      ApiUrl.reGenerateInvoicePDF(payload.invoiceId,payload.hourRate),
      this.request.reGenerateInvoicePDFRequest(payload,REQUEST_METHOD.POST),
      true
    )
    .then((response) =>{
      resolve(response);
    })
    .catch((error) =>{
      reject(error);
    })
  })
}


invoicePaymentDateRequest = (payload) => {
  return new Promise((resolve, reject) => {
   WebService.clientShared  
     .callServiceApi(
       ApiUrl.invoicePaymentDateUpdate(),
       this.request.invoicePaymentDateRequest(REQUEST_METHOD.PUT,payload)
     )
     .then((response) => {
       resolve(response);
     })
     .catch((error) => {
       reject(error);
     });
 }); 
} 

}